// Libraries
import { Box, Card, Text } from '@chakra-ui/react';
// Components
import text from '@translations/en.json';
// Types
import { CiiRatingSimulatorCardProps } from './CiiRatingSimulatorCard.types';

/**
 * A card component designed for Cii rating simulation display.
 *
 * @component
 * @param {CiiRatingSimulatorCardProps} props - The props for the CiiRatingSimulatorCard component.
 * @param {ReactNode} props.children - The child elements or components to be rendered inside the card.
 *
 * @returns {ReactElement} The CiiRatingSimulatorCard component.
 */
export const CiiRatingSimulatorCard = ({ children }: CiiRatingSimulatorCardProps) => {
  return (
    <Card w='full' gap={4} py={5} px={0}>
      <Box px={4}>
        <Text fontSize={{ base: 'md', md: 'xl' }} fontWeight='medium'>
          {text.cii_simulator.rating_simulation_card.title}
        </Text>
      </Box>
      {children}
    </Card>
  );
};
